export const MedicalDept = {
    DENT: 'DENT',
    DERM: 'DERM',
    PS: 'PS',
    OS: 'OS',
    OPH: 'OPH',
    COMMON: 'COMMON',
    VET_COMMON: 'VET_COMMON',
}

export const MedicalDeptText = {
    DENT: '치과',
    DERM: '피부과',
    PS: '성형외과',
    OS: '정형외과',
    OPH: '안과',
    COMMON: '공통',
    VET_COMMON: '수의과'
}

export function convertMedicalDept(value) {
    return MedicalDeptText[value] || '';
}
  
export const devices = {
    IOS: 'iOS',
    AOS: '안드로이드',
    ETC: '기타',
}

export const appTypes = {
    CUSTOMER: '환자',
    HOSPITAL: '병원',
}

export const colorCodes = [
    '#CDE5FF',
    '#CCD4FF',
    '#FFD913',
    '#7798ED',
    '#BBC1C6',
    '#FECFCD',
    '#C4F4C2',
    '#FFEEA9',
    '#FC6F28',
    '#9FC210',
    '#CBF5C0',
]

export const productCodeStatus = {
    notFound: 'notfound',
    exist: 'exist',
    ok: 'ok',
    notChecked: '',
}

export const colorCodeForCertifiedCompanies = {
    dentium: '#ACC90E',
    zeiss: '#141E8C',
}


export const ProductTypeEnum = {
    IMPLANT: '치아 임플란트',
    TRANSPARENTBRACE: '투명교정',
}

export const NftTitleEnum = {
    DENTIUM: '덴티움 정품 인증서',
    POINTIMPLANT: '포인트임플란트 정품 인증서',
    POINTIMPLANTUV: '포인트 UV 임플란트 인증서',
    WITHWELLIMPLANT: '위드웰임플란트 정품 인증서',
    PLASMAPP: '플라즈맵 정품 표면처리 인증서',
    ZEISS: '자이스 코리아', // 해야 됨
    PS_HOSPITAL: '수술 책임관리 인증서',
    PS_CERTIFIED: '정품 보형물 인증서',
    PS_NOTCERTIFIED: '보형물 시술 확인서',
    ETC: '임플란트 제품 확인서',
}

export const KlipCompanyNameEnum = {
    DENTIUM: '덴티움(Dentium)',
    POINTIMPLANT: '포인트임플란트(Point Implant)',
    WITHWELLIMPLANT: '위드웰임플란트(WithWell Implant)',
    PLASMAPP: '플라즈맵(Plasmapp)',
    ZEISS: '자이스 코리아',
    SUNMEDICAL: '썬메디칼(Sun Medical)',
    INNODTECH: '이노디테크(innoDtech)',
}

export const InformTextEnum = {
    DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
    ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
    ZEISS_OTHER: `문의사항은 해당 병원으로 부탁드립니다!.`,
}

export const TraitTypeEnum = {
    COMMON: {
        DEPT: '진료 과목',
        PRODUCTTYPE: '수술/시술 구분',
        HOSPITALNAME: '병원명',
        SURGERYDATE: '수술일',
        DOCTORNAME: '수술 의사',
        COMPANYNAME: '제조사',
        INFORMTEXT: '안내사항',
        ISSUEDBY: '발행주체',
        PRODUCTNAME: '제품명',
        SPEC: '제품 사양',
    },
    DENT: {
        TOOTHNO: '치아 번호',
        BRACEPART: '교정 부위',
    },
    OPH: {

    },
    PS: {
        IMPLANT_COMPANY: '보형물 제조사',
        IMPLANT_NAME: '보형물 제품명',
        IMPLANT_SPEC: '보형물 사양',
        IMPLANT_NO: '보형물 정품인증번호',
        LEFT_COMPANY: '보형물(L) 제조사',
        RIGHT_COMPANY: '보형물(R) 제조사',
        LEFT_NAME: '보형물(L) 제품명',
        RIGHT_NAME: '보형물(R) 제품명',
        LEFTSPEC: '보형물(L) 제품 사양',
        RIGHTSPEC: '보형물(R) 제품 사양',
        LEFTNO: '보형물(L) 정품인증번호',
        RIGHTNO: '보형물(R) 정품인증번호',
        NO: '보형물 정품인증번호',
    }
}

export const IssuanceMethodEnum = {
    PRODUCT_BASED_ISSUANCE: 'PRODUCT_BASED_ISSUANCE',                          // 상품별 발행
    TOOTH_BUNDLED_ISSUANCE: 'TOOTH_BUNDLED_ISSUANCE',                          // 치아별로 묶인 상품은 함께 발행
    BUNDLED_ISSUANCE: 'BUNDLED_ISSUANCE',                                      // 수술행위로 묶어서 발행시 사용
    MANUFACTURER_BASED_ISSUANCE: 'MANUFACTURER_BASED_ISSUANCE',                // 서로 다른 제조사인 경우 구분해서 발행
    PROJECT_BASED_ISSUANCE: 'PROJECT_BASED_ISSUANCE',                          // 프로젝트로 구분해서 발행
    SEOLBI_ALIMTALK_PUBLISH: 'SEOLBI_ALIMTALK_PUBLISH',                        // 건설기계공제조합 관련 알림톡 전송시
    CLARA_ALIMTALK_REGULARLY: 'CLARA_ALIMTALK_REGULARLY',                      // 클라라 알림톡 전송 시
}



export const enums = () => {
    return {
        WarrantyStatusEnum: {
            REQUEST_ISSUED: 'request-issued', // 발행 요청됨
            ISSUED: 'issued',                 // 지갑 저장됨
            DISPOSED: 'disposed',             // 삭제됨
            RETURNED: 'returned',             // 회수됨
            BIZ_SEND_ERROR: 'biz_send_error', // 발송 실패
            SEND_LMS: 'send-lms',             // 문자 전송됨
            SEND_BIZ: 'send-biz',             // 카톡 전송됨
            WECHAT_ISSUED: 'wechat-issued', // 위챗 전송됨
        },
        WarrantyStatusText: {
            ISSUED: '지갑 저장됨',        // ISSUED
            DISPOSED: '삭제됨',           // DISPOSED 
            RETURNED: '회수됨',          // RETURNED 
            BIZ_SEND_ERROR: '발송 실패',    // BIZ_SEND_ERROR
            SEND_LMS: '문자 전송됨',      // SEND_LMS //
            SEND_BIZ: '카톡 전송됨'       // SEND_BIZ //
        },
        NftTitleEnum: {
            DENTIUM: '덴티움 정품 인증서',
            PLASMAPP: '플라즈맵 정품 표면처리 인증서',
            ZEISS: '자이스 코리아', // 해야 됨
            PS_HOSPITAL: '수술 책임관리 인증서',
            PS_CERTIFIED: '정품 보형물 인증서',
            PS_NOTCERTIFIED: '보형물 시술 확인서',
            ETC: '임플란트 제품 확인서',
        },
            KlipCompanyNameEnum: {
            DENTIUM: '덴티움(Dentium)',
            PLASMAPP: '플라즈맵(Plasmapp)',
            ZEISS: '자이스 코리아',
            SUNMEDICAL: '썬메디칼(Sun Medical)',
        },
        InformTextEnum: {
            DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
            ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
        },
        TraitTypeEnum: {
            COMMON: {
                DEPT: '진료 과목',
                PRODUCTTYPE: '수술/시술 구분',
                HOSPITALNAME: '병원명',
                SURGERYDATE: '수술일',
                DOCTORNAME: '수술 의사',
                COMPANYNAME: '제조사',
                INFORMTEXT: '안내사항',
                ISSUEDBY: '발행주체',
                PRODUCTNAME: '제품명',
                SPEC: '제품 사양',
            },
            DENT: {
                TOOTHNO: '치아 번호',
            },
            OPH: {
            
            },
            PS: {
                IMPLANT_COMPANY: '보형물 제조사',
                IMPLANT_NAME: '보형물 제품명',
                IMPLANT_SPEC: '보형물 사양',
                IMPLANT_NO: '보형물 정품인증번호',
                LEFT_COMPANY: '보형물(L) 제조사',
                RIGHT_COMPANY: '보형물(R) 제조사',
                LEFT_NAME: '보형물(L) 제품명',
                RIGHT_NAME: '보형물(R) 제품명',
                LEFTSPEC: '보형물(L) 제품 사양',
                RIGHTSPEC: '보형물(R) 제품 사양',
                LEFTNO: '보형물(L) 정품인증번호',
                RIGHTNO: '보형물(R) 정품인증번호',
                NO: '보형물 정품인증번호',
            }
        },
        YnEnum: {
            Y: 'Y',
            N: 'N'
        },
    };
}
  
export default enums;